import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDmTrangThaiLeadActionTypes } from "../../action-types/crm-category/IDmTrangThaiLeadActionTypes";
import { IDmTrangThaiLeadReducer } from "../../page-state-model/crm-category/IDmTrangThaiLeadReducer";

const iniState: IDmTrangThaiLeadReducer = {
    status: ePageBaseStatus.is_not_initialization,
    trangThaiLeads: []
}

export const dmTrangThaiLeadReducer = (state: IDmTrangThaiLeadReducer = iniState, action: IDmTrangThaiLeadActionTypes): IDmTrangThaiLeadReducer => {
    switch (action.type) {
        case "DM_TRANG_THAI_LEAD_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DM_TRANG_THAI_LEAD_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                trangThaiLeads: action.payload
            }
        case "DM_TRANG_THAI_LEAD_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                trangThaiLeads: []
            }
        case "DM_TRANG_THAI_LEAD_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "DM_TRANG_THAI_LEAD_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DM_TRANG_THAI_LEAD_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "DM_TRANG_THAI_LEAD_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "DM_TRANG_THAI_LEAD_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "DM_TRANG_THAI_LEAD_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "DM_TRANG_THAI_LEAD_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "DM_TRANG_THAI_LEAD_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}
